var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_document-text",
    "data-name": "vuesax/linear/document-text",
    transform: "translate(-492 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(492 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25,3.958v7.917c0,2.375-1.187,3.958-3.958,3.958H3.958C1.188,15.833,0,14.25,0,11.875V3.958C0,1.583,1.188,0,3.958,0h6.333C13.063,0,14.25,1.583,14.25,3.958Z",
    transform: "translate(2.375 1.583)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V1.583A1.588,1.588,0,0,0,1.583,3.167H3.167",
    transform: "translate(11.479 3.563)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H3.167",
    transform: "translate(6.333 10.292)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H6.333",
    transform: "translate(6.333 13.458)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.33e698450e0de16aebe2d4e2d747c62f.svg";
export { ForwardRef as ReactComponent };